<template>
  <div class="page login-page">
    <div class="loading" v-if="loading"></div>
    <div class="weui-form" v-if="!loading && !hasAuthInfo">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">企业注册</h2>
      </div>
      <div class="weui-form__control-area">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="selector">
            <span :class="{ 'span-selected': signInfo.areaCategory == 10 }">
              <input type="radio" name="area" id="中国大陆" v-model="signInfo.areaCategory" :value="10" />
              <label for="中国大陆"> {{ "中国大陆" }}</label>
            </span>
            <span :class="{ 'span-selected': signInfo.areaCategory == 20 }">
              <input type="radio" name="area" id="其他地区" v-model="signInfo.areaCategory" :value="20" />
              <label for="其他地区"> {{ "其他地区" }}</label>
            </span>
          </div>
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <div class="weui-label">姓名</div>
              </div>
              <div class="weui-cell__bd">
                <input v-model="signInfo.userName" class="weui-input" placeholder="请输入您的真实姓名" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <div class="weui-label">手机号</div>
              </div>
              <div class="weui-cell__bd">
                <input v-model="signInfo.mobile" class="weui-input" placeholder="请输入您的手机号码" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active weui-cell_vcode">
              <div class="weui-cell__hd">
                <div class="weui-label">验证码</div>
              </div>
              <div class="weui-cell__bd">
                <input v-model="signInfo.validCode" class="weui-input" placeholder="请输入验证码" />
              </div>
              <div class="weui-cell__ft" @click="getValidCode">
                <button class="weui-btn weui-btn_default weui-vcode-btn" :class="{ 'weui-btn_disabled': isLocked }">
                  <span v-if="!waitTime">获取</span><span v-else>{{ waitTime }}秒后再试</span>
                </button>
              </div>
            </div>
            <qcc-search-box v-if="signInfo.areaCategory == 10 && isMobileChecked" label="所在企业" placeholder="请输入企业名称"
              v-model="signInfo.companyName" @select="onCompanySelect($event)"></qcc-search-box>
            <div class="weui-cell weui-cell_active" v-if="signInfo.areaCategory == 20">
              <div class="weui-cell__hd">
                <div class="weui-label">所在企业</div>
              </div>
              <div class="weui-cell__bd">
                <input v-model="signInfo.companyName" class="weui-input" placeholder="请输入企业名称" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active" v-if="signInfo.areaCategory == 20">
              <div class="weui-cell__hd">
                <div class="weui-label">登记证号</div>
              </div>
              <div class="weui-cell__bd">
                <input v-model="signInfo.businessCode" class="weui-input" placeholder="营业执照号/登记证号" />
              </div>
            </div>
          </div>
        </div>
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells__title">行业类型</div>
          <div class="weui-cells weui-cells_radio">
            <label class="weui-cell weui-cell_active weui-check__label" for="x11">
              <div class="weui-cell__bd">
                <p>其他行业</p>
              </div>
              <div class="weui-cell__ft">
                <input type="radio" class="weui-check" v-model="signInfo.appId" value="trade-app" checked="checked"
                  id="x11" />
                <span class="weui-icon-checked"></span>
              </div>
            </label>
            <label class="weui-cell weui-cell_active weui-check__label" for="x12">
              <div class="weui-cell__bd">
                <p>制造业</p>
              </div>
              <div class="weui-cell__ft">
                <input type="radio" v-model="signInfo.appId" value="make-app" class="weui-check" id="x12" />
                <span class="weui-icon-checked"></span>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div class="weui-form__opr-area opr-block">
        <a class="weui-btn weui-btn__auto weui-btn_primary" :class="{ 'weui-btn_disabled': !isValidForm }"
          @click="register">注册</a>
      </div>
    </div>
    <div v-if="hasAuthInfo">
      <div class="page__hd">
        <div class="page__title">{{ authInfo.account.realname }}</div>
        <div class="page__desc">{{ authInfo.account.defaultCompany.name }}</div>
      </div>
      <div class="page__bd">
        <launch-weapp label="进入企业圈" :query="'token=' + authInfo.token" />
      </div>
    </div>
  </div>
</template>

<script>
import Validator from "@/util/validator.js";
import wait from "@/mixins/wait.js";
import captcha from "@/mixins/captcha.js";
import Auth from "@/util/auth.js";
import QccSearchBox from "@/components/field/QccSearchBox";
import LaunchWeapp from "@/components/button/LaunchWeapp.vue";

export default {
  mixins: [wait, captcha],
  components: {
    QccSearchBox,
    LaunchWeapp,
  },
  data() {
    return {
      signInfo: {
        areaCategory: 10,
        companyName: null,
        businessCode: null,
        userName: null,
        mobile: null,
        validCode: null,
        appId: "trade-app",
        inviteCode: null,
      },
      hasAuthInfo: false,
      authInfo: {},
      validCodeSend: false,
      loading: true,
    };
  },
  computed: {
    isMobileValid() {
      return Validator.isMobile(this.signInfo.mobile);
    },
    isLocked() {
      const me = this;
      return !me.isMobileValid || me.isWaiting;
    },
    isValidForm() {
      const me = this,
        signInfo = me.signInfo;
      return (
        me.isMobileValid &&
        signInfo.companyName &&
        (signInfo.businessCode || signInfo.areaCategory == 20) &&
        signInfo.userName &&
        signInfo.validCode
      );
    },
    isMobileChecked() {
      return this.isMobileValid && this.validCodeSend;
    },
    registerData() {
      return JSON.stringify(this.signInfo);
    },
  },
  created() {
    this.getAuthInfo();
  },
  methods: {
    /**
     * 获取验证码
     */
    getValidCode() {
      const me = this;
      if (me.isLocked) {
        return;
      }
      me.$captcha.show();
      me.$bus.$on('getTicket', res => {
        if (res.ret === 0) {
          me.addWaitTask();
          me.$loading({
            url: "/api/account/company/register/vcode",
            method: "POST",
            params: {
              mobile: me.signInfo.mobile,
              ticket: res.ticket,
              appId: res.appid,
              randstr: res.randstr
            },
          }).then(function (res) {
            if (res.success) {
              me.$weui.toast("发送成功", 2000);
              me.validCodeSend = true;
            } else {
              me.$weui.topTips("发送失败", 3000);
              me.clearWaitTask();
            }
          });
        } else {
          me.$weui.topTips('未通过验证');
        }
        me.$bus.$off('getTicket')
      })
    },
    /**
     * 主动获取cookie身份信息
     */
    getAuthInfo() {
      var me = this;
      Auth.get()
        .then(function (data) {
          me.loading = false;
          me.authInfo = data;
          var account = data.account;
          me.hasAuthInfo = account && account.companyId;
        })
        .catch(function () {
          me.loading = false;
        });
    },
    /**
     * 企业名模糊查询选择
     */
    onCompanySelect(company) {
      var code = company.creditCode;
      if (!code || !code.length) {
        code = company.no;
      }
      this.signInfo.businessCode = code;
    },
    /**
     * 注册
     */
    register() {
      const me = this;
      if (!me.isValidForm) {
        return;
      }
      me.$loading({
        url: "/api/account/company/register/v2",
        method: "POST",
        jsonData: me.signInfo,
      }).then(function (res) {
        if (res.success) {
          let authData = res.data;
          me.authInfo = Auth.set(authData);
          me.hasAuthInfo = true;
          me.$weui.toast("注册成功", 2000);
        } else {
          me.$weui.topTips("注册失败：" + res.message, 3000);
        }
      });
    },
  },
};
</script>

<style scoped>
.opr-block {
  padding: 0 32px;
}

.page__hd {
  padding: 40px;
}

.page__title {
  text-align: left;
  font-size: 20px;
  font-weight: 400;
}

.page__desc {
  margin-top: 4px;
  color: var(--weui-FG-1);
  text-align: left;
  font-size: 14px;
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -80px 0 0 -40px;
  width: 80px;
  height: 80px;
  border: 3px solid #d0d3d4;
  border-top-color: #626567;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}

.selector {
  margin: 0px 30px 20px 30px;
  display: flex;
  justify-content: space-between;
}

.selector span {
  width: 40%;
  border: 1px solid #ccc;
  padding: 8px 5px 7px 5px;
  border-radius: 5px;
  text-align: center;
}

.span-selected {
  font-weight: bold;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>

